import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[neorisBrokenImage]'
})
export class BrokenImageDirective {

  constructor(private elementRef: ElementRef) {

  }

  @HostListener('error')
  LoadDefaultImage() {
    const element = this.elementRef.nativeElement
    element.src = '../../../../../assets/images/white.png'
  }

}
